import { HttpClient } from '@shared/adapters/HttpClient';

export interface UnlinkedProductLine {
  id: number;
  product_id: number | null;
  pack_id: number | null;
  save_link_for_future?: boolean;
  apply_to_imported_orders?: boolean;
}

export interface UnlinkedProductsErrorRequest {
  lines: UnlinkedProductLine[];
}

export interface UnlinkedProductsErrorResponse {
  success: boolean;
  message: string;
}

export interface UnlinkedLinesCountResponse {
  shop_id: string;
  variant_id: string;
  orders_count: number;
  lines_count: number;
}

export interface LinkOrderLinesResponse {
  updated_lines: number;
  skipped_lines: number;
  errors: number;
}

export class UnlinkedProductsErrorApiAdapter {
  constructor(private httpClient: HttpClient) { }

  async solveUnlinkedProductsError(
    orderId: number,
    data: UnlinkedProductsErrorRequest
  ): Promise<UnlinkedProductsErrorResponse> {
    try {
      console.log(
        '🔍 UnlinkedProductsErrorApiAdapter - Solving unlinked products error:',
        {
          orderId,
          data,
        }
      );

      const response = await this.httpClient.put<{ message?: string }>(
        `/orders/${orderId}/solve-error/unlinked-product`,
        data
      );

      console.log('🔍 UnlinkedProductsErrorApiAdapter - Response:', response);

      return {
        success: true,
        message: response?.message || 'Productos enlazados correctamente',
      };
    } catch (error: any) {
      console.log('🔍 UnlinkedProductsErrorApiAdapter - Error:', error);
      throw error;
    }
  }

  /**
   * Obtiene el conteo de líneas de pedido sin vincular para un variant_id específico
   * GET /orders/unlinked-lines?shop_id={shopId}&variant_id={variantId}
   */
  async getUnlinkedLinesCount(
    shopId: number,
    variantId: string
  ): Promise<UnlinkedLinesCountResponse> {
    try {
      console.log(
        '🔍 UnlinkedProductsErrorApiAdapter - Getting unlinked lines count:',
        { shopId, variantId }
      );

      const response = await this.httpClient.get<UnlinkedLinesCountResponse>(
        `/orders/unlinked-lines?shop_id=${shopId}&variant_id=${variantId}`
      );

      console.log(
        '🔍 UnlinkedProductsErrorApiAdapter - Unlinked lines count response:',
        response
      );

      return response;
    } catch (error: any) {
      console.log(
        '🔍 UnlinkedProductsErrorApiAdapter - Error getting unlinked lines count:',
        error
      );
      throw error;
    }
  }

  /**
   * Vincula todas las líneas de pedido sin vincular que contengan un variant_id específico
   * PUT /orders/link-lines?shop_id={}&variant_id={}&product_id={} o pack_id={}
   */
  async linkOrderLines(params: {
    shopId: number;
    variantId: string;
    productId?: number;
    packId?: number;
  }): Promise<LinkOrderLinesResponse> {
    try {
      const { shopId, variantId, productId, packId } = params;

      console.log(
        '🔍 UnlinkedProductsErrorApiAdapter - Linking order lines:',
        params
      );

      let url = `/orders/link-lines?shop_id=${shopId}&variant_id=${variantId}`;
      if (productId) {
        url += `&product_id=${productId}`;
      }
      if (packId) {
        url += `&pack_id=${packId}`;
      }

      const response = await this.httpClient.put<LinkOrderLinesResponse>(url, null);

      console.log(
        '🔍 UnlinkedProductsErrorApiAdapter - Link order lines response:',
        response
      );

      return response;
    } catch (error: any) {
      console.log(
        '🔍 UnlinkedProductsErrorApiAdapter - Error linking order lines:',
        error
      );
      throw error;
    }
  }
}
